import clsx from 'clsx'
import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'

// import { useCreatePersistentPlatformMural } from 'api/mutations/mutateCeatePersistentPlatformMural'
import styles from 'app/App.module.scss'
import NewBanner from 'components/common/newBanner/NewBanner'
import { Skeleton } from 'components/uikit/Skeleton/Skeleton'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

import BottomArc from '../components/common/bottomArc/BottomArc'
import Hero from '../components/hero/Hero'
import MarqueeText from '../components/marquee/MarqueeText'
import PersistentPlatform from '../components/persistentPlatform/PersistentPlatform'
import Questions from '../components/questions/Questions'

export function App() {
  // const { mutateAsync: createMural, isPending, isSuccess, data } = useCreatePersistentPlatformMural() /*== collider API is depricated, new endpoint will be added once available ==*/
  const isPending = false
  const isSuccess = true
  const muralData = {
    data: {
      visitorsSettings: {
        link: 'https://app.mural.co/t/marketing6265/m/marketing6265/1781093760554/b15b52c97c5e5ffd6b8135ca52864e9c2890dfbf',
      },
    },
  }

  useEffect(() => {
    // createMural(undefined)

    trackAnalytics({
      type: AnalyticsActionType.page,
      payload: EVENTS.PAGES.PLAYGROUND_PP,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BrowserRouter basename="/persistent-platform">
      <div className={styles.container}>
        <Hero />
        <PersistentPlatform createMuralIsLoading={isPending} muralData={muralData} muralIsSuccess={isSuccess} />
        {/* <div className={clsx(styles.sectionContainer, 'flex justify-between gap-x-0.5 min-h-[360px]')}>
          <NewBanner
            image="left"
            buttonText="Download Template"
            buttonUrl="https://cokeurl.com/persist-platf-template"
            title="Build your framework by downloading the Persistent Platform Template."
            text="Once complete, upload it here to keep it available for reference."
            additionalContent="fileUpload"
            imagePositionBottom
            bannerPosition="left"
            onClick={() => {
              trackAnalytics({
                type: AnalyticsActionType.action,
                payload: EVENTS.ACTIONS.PLAYGROUND_PP_TEMPLATE,
              })
            }}
          />
          {!isPending && isSuccess && muralData?.data.visitorsSettings?.link && (
            <NewBanner
              image="both"
              buttonText="Access Your Mural Template"
              buttonUrl={muralData.data?.visitorsSettings?.link || ''}
              title={data.data.title}
              text="Follow the Mural exercise to gain inspiration and references for your project."
              additionalContent="image"
              imageUrl="../assets/images/other/nudge_background.png"
              imagePositionBottom
              bannerPosition="right"
              onClick={() => {
                trackAnalytics({
                  type: AnalyticsActionType.action,
                  payload: EVENTS.ACTIONS.PLAYGROUND_PP_MURAL,
                })
              }}
            />
          )}
          {isPending && <WppSkeleton height={376} className="rounded-[16px] relative max-w-[1258px] w-full" />}
        </div> */}
        <div className="tour-persistentplatform-qanda">
          <MarqueeText />
          <Questions />
        </div>
        <div
          className={clsx(
            styles.sectionContainer,
            'flex justify-between gap-x-0.5 !mb-10 mx-auto tour-persistentplatform-productcentricapproach_Mural_XLoop',
          )}
        >
          <NewBanner
            image="left"
            buttonText="Check Resources"
            buttonUrl={`${process.env.REACT_APP_TIPS_AND_TRICKS}?tab=3` || ''}
            title="Interested in learning more about the Product Centric Approach?"
            text="Access this folder to leverage more resources and get inspired."
            bannerPosition="left"
            onClick={() => {
              trackAnalytics({
                type: AnalyticsActionType.action,
                payload: EVENTS.ACTIONS.PLAYGROUND_PP_RESOURCES,
              })
            }}
          />
          {!isPending && isSuccess && muralData?.data.visitorsSettings?.link && (
            <NewBanner
              image="none"
              buttonText="Access the Mural Template"
              buttonUrl={muralData?.data?.visitorsSettings?.link || ''}
              title="Strategy Lens Mural"
              text="Follow the Mural exercise to gain inspiration and references for your project."
              bannerPosition="center"
              onClick={() => {
                trackAnalytics({
                  type: AnalyticsActionType.action,
                  payload: EVENTS.ACTIONS.PLAYGROUND_PP_MURAL,
                })
              }}
            />
          )}
          {isPending && <Skeleton height={376} className="rounded-[16px] relative max-w-[1258px] w-full" />}
          <NewBanner
            image="right"
            title="Create magic with the Experience Loop."
            text="Bring the inspiration fueled from your Persistent Platform Framework to your next Experience Loop project."
            buttonText="Go to Experience Loop"
            buttonUrl={process.env.REACT_APP_XLOOP || ''}
            bannerPosition="right"
            onClick={() => {
              trackAnalytics({
                type: AnalyticsActionType.action,
                payload: EVENTS.ACTIONS.PLAYGROUND_PP_LOOP,
              })
            }}
          />
        </div>
        <BottomArc />
      </div>
    </BrowserRouter>
  )
}
